const Contact = () => import('./Main')

const route = {
  path: '/contact',
  name: 'contact',
  meta: {
    title: 'Contact - A D M A N 2 0 1 9'
  },
  component: Contact
}

export default route
